export const environment = {
  production: false,
  apiurl:
  "https://api-digital-uat.maxis.com.my/uat/api/v1.0/acknowledgement",
  legalcodumenturl: "https://api-digital-uat.maxis.com.my/uat/api/v1.0/legaldocument",
  defaultlanguage: "en-US",
  iscsportal: false,
  maxis_channel_type: "SS",
  legalapikey: "94c826cc-8598-471f-8e97-afd4dbb92861",
  apikey: "94c826cc-8598-471f-8e97-afd4dbb92861",
  isMaintenance: false,
}; 
